var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSocialchannelNewsletter = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4 10v14l6.68-6.95-6.68-7.050zM28 8h-24l12 13 12-13zM20.35 18.080l-4.35 4.92-4.58-5.13-5.42 6.13h20l-5.65-5.92zM28 24v-14l-6.89 7.27 6.89 6.73z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSocialchannelNewsletter);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/socialchannel-newsletter.4e7fc7378aaed9bfbd9a13f3a992ea3e.svg";